import { loader } from 'graphql.macro'

export default function userQuery ({ dataLoaders }) {
  const userSchema = loader('./user.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(userSchema)
}
